import "./RedirectButton.less";

import { Button } from "antd";
import { ButtonProps } from "antd/lib/button";
import * as React from "react";
import { Redirect } from "react-router-dom";

import { IBaseProps } from "lib/data/interfaces";

interface IRedirectButtonProps extends IBaseProps, ButtonProps {
	push?: boolean;
}

interface IRedirectButtonState {
	isNavigating: boolean;
}


export class RedirectButton extends React.Component<IRedirectButtonProps, IRedirectButtonState> {

	public static defaultProps = {
		push: true
	};

	constructor(props: IRedirectButtonProps) {

		super(props);

		this.state = {
			isNavigating: false
		};
	}

	public componentWillUpdate(_nextProps: IRedirectButtonProps, nextState: IRedirectButtonState) {

		// Check If Already Navigating
		if (nextState.isNavigating) {

			// Reset Navigation
			this.setState({ isNavigating: false });
		}
	}

	public render() {

		// Check For Navigation
		if (this.state.isNavigating) {

			// Redirect
			return <Redirect to={this.props.href as string} push={this.props.push} exact={true} />;
		}

		const storedProps: IRedirectButtonProps = { ...this.props };
		delete storedProps.push;

		return (

			<Button
				{...storedProps}
				href={undefined}
				onClick={this.onClick}
			/>
		);
	}

	private onClick = async (): Promise<void> => {

		// Check For Destination
		if (this.props.href && this.props.href !== "") {

			// Indicate Navigation Is Occurring
			this.setState({ isNavigating: true });
		}
	}
}
